import React from 'react';
import { useFormDepartureContext } from '../../../components/FormDepartureContext';
import CustomSelect from '../../../components/shared/CustomSelect';

const LABELS = { jobTitle: 'Ticket Title', jobType: 'Ticket Type', jobDescription: 'Ticket Description' };

const JOB_TYPE_OPTIONS = [
  'Cancel Shift', 'Additional Clean', 'Builders Clean', 'Detail Clean', 'Request Audit',
  'Request Site Inspection', 'Periodical Carpark Clean', 'Periodical Carpet Clean',
  'External Service', 'Feed back', 'Fridge Clean', 'Hard Floor Clean', 'Rectification Clean',
  'Specialist Clean Outside Of Scope', 'Steam Clean Carpet', 'Window Clean', 'Periodical', 'Order Request',
];

const ErrorIcon = () => (
  <svg fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
  </svg>
);

const JobInfoSection = () => {
  const { formData, formErrors, modifiedFields, setFieldValue, setFormErrors, setModifiedFields } = useFormDepartureContext();

  const applyError = (field, error) => {
    if (error) setFormErrors((prev) => ({ ...prev, [field]: error }));
    else setFormErrors((prev) => { const n = { ...prev }; delete n[field]; return n; });
  };

  const handleChange = (field, value) => {
    setFieldValue(field, value);
    setModifiedFields((prev) => new Set([...prev, field]));
    applyError(field, String(value ?? '').trim() === '' ? `${LABELS[field]} is required` : null);
  };

  const showErr = (field) => formErrors[field] && modifiedFields?.has?.(field);
  const inputClass = (field) => `ob-input ${showErr(field) ? 'ob-input-error' : ''}`;

  return (
    <div className="form-section">
      <h4 className="ob-record-title" style={{ marginBottom: 12 }}>Ticket Information</h4>

      <div style={{ display: 'grid', gap: 20 }}>
      <div className="ob-field">
        <label htmlFor="job-Title" className="ob-label">Ticket Title <span className="ob-label-required">*</span></label>
        <input id="job-Title" type="text" value={formData.jobTitle}
          onChange={(e) => handleChange('jobTitle', e.target.value)}
          placeholder="Enter a descriptive ticket title" className={inputClass('jobTitle')} />
        {showErr('jobTitle') && <div className="ob-error"><ErrorIcon />{formErrors.jobTitle}</div>}
      </div>

      <div className="ob-field">
        <CustomSelect label="Ticket Type" value={formData.jobType}
          onChange={(v) => handleChange('jobType', v)} options={JOB_TYPE_OPTIONS} />
        {showErr('jobType') && <div className="ob-error"><ErrorIcon />{formErrors.jobType}</div>}
      </div>

      <div className="ob-field">
        <label htmlFor="job-Description" className="ob-label">Ticket Description <span className="ob-label-required">*</span></label>
        <textarea id="job-Description" rows="4" value={formData.jobDescription}
          onChange={(e) => handleChange('jobDescription', e.target.value)}
          placeholder="Provide detailed information about this ticket"
          className={inputClass('jobDescription')} style={{ resize: 'vertical', minHeight: 110 }} />
        {showErr('jobDescription') && <div className="ob-error"><ErrorIcon />{formErrors.jobDescription}</div>}
      </div>

      <div className="ob-record-card" style={{ padding: '10px 12px' }}>
        <p className="ob-subtitle" style={{ margin: 0 }}>
          <span style={{ fontWeight: 600 }}>Tip:</span> Be as specific as possible so the request is fulfilled correctly.
        </p>
      </div>
      </div>
    </div>
  );
};

export default JobInfoSection;